module.exports = __webpack_public_path__ + "static/city_icon_92-acad45bfef88c996205516595646cbd0.png";